
export default {


    'samples': true,
    'production': '',
    // 'production': '/officeride'
}
